// extracted by mini-css-extract-plugin
export default {"buttonBaseStyle":"IsDefaultColumn_buttonBaseStyle__2BVRP","errorModal":"IsDefaultColumn_errorModal__hqcGX"};